import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _merge from "lodash/merge";
import _isNil from "lodash/isNil";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var samplesFileUpdate = function samplesFileUpdate(state, action) {
  var _state$sampleUuid$fil;
  var _action$payload = action.payload,
    sampleUuid = _action$payload.sampleUuid,
    sampleFileType = _action$payload.sampleFileType,
    fileDiff = _action$payload.fileDiff,
    lastModified = _action$payload.lastModified;

  // There's a possible race condition where a file update can reach this place
  // after a sample is deleted and there's a crash. This check is in place to avoid that error.
  if (_isNil(state[sampleUuid])) {
    return state;
  }
  var oldFile = (_state$sampleUuid$fil = state[sampleUuid].files) === null || _state$sampleUuid$fil === void 0 ? void 0 : _state$sampleUuid$fil[sampleFileType];
  var newFile = fileDiff;
  if (oldFile) {
    newFile = _merge({}, oldFile, fileDiff);
  }
  return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, sampleUuid, _objectSpread(_objectSpread({}, state[sampleUuid]), {}, {
    files: _objectSpread(_objectSpread({}, state[sampleUuid].files), {}, _defineProperty({}, sampleFileType, _objectSpread({}, newFile))),
    lastModified: lastModified
  })));
};
export default samplesFileUpdate;